import React, { useEffect } from "react";
import { useState } from "react";
import "antd/dist/antd.css";
import { Input, Row, Col, Button, Checkbox, Comment, List } from "antd";
import moment from "moment";

function CommentBox(props) {
  const [commentBox, setCommentBox] = useState([]);
  const [error, setError] = useState(false);
  const [sendPanelist, setSendPanelist] = useState(false);
  const [comments, setComments] = useState({});
  const [value, setValue] = useState("");

  useEffect(() => {
    loadComments();
  }, []);

  useEffect(() => {}, [commentBox]);

  const cleanJSON = (str) => {
    return str.replace(/[\u0000-\u001F]+/g, "");
  };
  const loadComments = () => {
    let tempArray = [];
    if (props.comment) {
      try {
        const safeString = cleanJSON(props.comment);
        const parsed = JSON.parse(safeString);
        Object.values(JSON.parse(props.comment)).map((val) =>
          tempArray.push({
            author: "Specialist",
            content: (
              <>
                <p>{val[1]}</p>
                {val[0] === 1 ? (
                  <p className="send-text">Sent to Panelist</p>
                ) : (
                  <></>
                )}
              </>
            ),
          })
        );
      } catch (error) {
        console.error("Error parsing comment", error, props.comment);
      }
      setComments(tempArray);
      setCommentBox(tempArray);
    } else {
      setComments([]);
    }
  };

  function postComment() {
    if (value) {
      setError(false);
      props.handlePostComment(value, sendPanelist);
    } else {
      setError(true);
    }
  }

  const CommentList = ({ comments }) => (
    <div id="scrollableDiv" className="comment">
      <List
        dataSource={comments}
        itemLayout="horizontal"
        renderItem={(props) => <Comment {...props} />}
      />
    </div>
  );

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col md={24}>
          {comments.length > 0 && <CommentList comments={comments} />}
          <Comment
            content={
              <Input.TextArea
                onChange={(e) => setValue(e.target.value)}
                allowClear
                placeholder="Comment"
                autoSize={{ minRows: 3, maxRows: 3 }}
                value={value}
                datetime={moment().fromNow()}
              />
            }
          />
          {error && <div className="text-color">*Required Field</div>}
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col md={24}>
          <div className="space">
            <Checkbox
              checked={sendPanelist}
              onChange={() => setSendPanelist(!sendPanelist)}
            >
              Send to Panelist
            </Checkbox>
            <div className="order">
              <Button
                key="back"
                className="button-style"
                onClick={() => props.setCommentModalOpen(null)}
              >
                <>Close</>
              </Button>
              <Button
                key="submit"
                type="secondary-button"
                onClick={() => {
                  if (value) {
                    setComments([
                      ...comments,
                      {
                        author: "Specialist",
                        content: (
                          <>
                            <p>{value}</p>
                            {sendPanelist ? (
                              <p className="panelist-style">Sent to Panelist</p>
                            ) : (
                              <></>
                            )}
                          </>
                        ),
                      },
                    ]);
                    setValue("");
                    setSendPanelist(false);
                    postComment();
                  } else {
                    setError(true);
                  }
                }}
              >
                Post
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default CommentBox;
